import {defineSlotRecipe} from '@chakra-ui/react3'
import {infoTooltipSizes, infoTooltipStyles} from './info-tooltip-styles'

export const popoverSlotRecipe = defineSlotRecipe({
    className: 'chakra-popover',
    slots: [
        'arrow',
        'arrowTip',
        'anchor',
        'trigger',
        'indicator',
        'positioner',
        'content',
        'title',
        'description',
        'closeTrigger',
        'header',
        'body',
        'footer'
    ],
    base: {
        ...infoTooltipStyles,
        content: {
            ...infoTooltipStyles.content,
            '--popover-z-index': 'zIndex.popover',
            zIndex: 'calc(var(--popover-z-index) + var(--layer-index, 0))',
            transformOrigin: 'var(--transform-origin)',
            maxHeight: 'var(--available-height)',
            outline: '0',
            _open: {
                animationStyle: 'scale-fade-in',
                animationDuration: 'fast'
            },
            _closed: {
                animationStyle: 'scale-fade-out',
                animationDuration: 'faster'
            }
        }
    },
    variants: {
        triggerMode: {
            responsive: {
                trigger: {'@media (hover: hover) and (pointer: fine)': {display: 'none'}}
            }
        },
        variant: {
            promoPopover: {
                positioner: {boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)'},
                content: {
                    '--info-tooltip-bg': 'colors.white',
                    paddingBlock: '2',
                    paddingInline: '3',
                    border: '1px solid transparent',
                    borderRadius: 'md',
                    boxShadow: 'sm',
                    fontSize: 'md'
                },
                body: {paddingInline: '3', paddingBlock: '2'}
            }
        },
        size: infoTooltipSizes
    },
    defaultVariants: {
        size: 'full'
    }
})
